{
  "AUDIT_LOGS": {
    "HEADER": "Denetim Kayıtları",
    "HEADER_BTN_TXT": "Denetim Kaydı Ekle",
    "LOADING": "Denetim Kayıtları Alınıyor",
    "DESCRIPTION": "Audit Logs maintain a record of activities in your account, allowing you to track and audit your account, team, or services.",
    "LEARN_MORE": "Learn more about audit logs",
    "SEARCH_404": "Bu sorgu ile eşleşen öğe yok",
    "SIDEBAR_TXT": "<p><b>Denetim Kayıtları</b></p><p>Denetim Kayıtları, sistemdeki olaylar ve eylemler için izlerdir.</p>",
    "LIST": {
      "404": "Bu hesapta kullanılabilir denetim kaydı yok.",
      "TITLE": "Denetim Kayıtlarını Yönet",
      "DESC": "Denetim Kayıtları, sistemdeki olaylar ve eylemler için izlerdir.",
      "TABLE_HEADER": {
        "ACTIVITY": "Kullanıcı",
        "TIME": "Eylem",
        "IP_ADDRESS": "IP Adresi"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "Denetim Kayıtları başarıyla alındı",
      "ERROR_MESSAGE": "Woot Sunucusuna bağlanılamadı, Lütfen daha sonra tekrar deneyin"
    },
    "DEFAULT_USER": "Sistem",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} created a new automation rule (#{id})",
      "EDIT": "{agentName} updated an automation rule (#{id})",
      "DELETE": "{agentName} deleted an automation rule (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName}, {invitee}'yi {role} olarak hesaba davet etti",
      "EDIT": {
        "SELF": "{agentName}, {attributes}ını {values} olarak değiştirdi",
        "OTHER": "{agentName}, {user}'ın {attributes}ını {values} olarak değiştirdi",
        "DELETED": "{agentName} changed {attributes} of a deleted user to {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} created a new inbox (#{id})",
      "EDIT": "{agentName} updated an inbox (#{id})",
      "DELETE": "{agentName} deleted an inbox (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} created a new webhook (#{id})",
      "EDIT": "{agentName} updated a webhook (#{id})",
      "DELETE": "{agentName} deleted a webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} giriş yaptı",
      "SIGN_OUT": "{agentName} çıkış yaptı"
    },
    "TEAM": {
      "ADD": "{agentName} created a new team (#{id})",
      "EDIT": "{agentName} updated a team (#{id})",
      "DELETE": "{agentName} deleted a team (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} created a new macro (#{id})",
      "EDIT": "{agentName} updated a macro (#{id})",
      "DELETE": "{agentName} deleted a macro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} added {user} to the inbox(#{inbox_id})",
      "REMOVE": "{agentName} removed {user} from the inbox(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} added {user} to the team(#{team_id})",
      "REMOVE": "{agentName} removed {user} from the team(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} updated the account configuration (#{id})"
    },
    "CONVERSATION": {
      "ADD": "{agentName} bir görüşme oluşturdu (#{id})",
      "EDIT": "{agentName} bir görüşmeyi güncelledi (#{id}): {changes}"
    },
    "CONTACT": {
      "ADD": "{agentName} bir kişi oluşturdu (#{id})",
      "EDIT": "{agentName} bir kişiyi güncelledi (#{id}): {attributes}"
    }
  }
}
